import VenueDetailsFields from './VenueDetailsFields';
export default VenueDetailsFields;
